import { Container, TextWrapper, ScoreWrapper, Wrapper, Img } from './CompanyItemStyles';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import exposureImg from '@/assets/exposure.svg';

const CompanyItem = ({ data }) => {
  const data_ = Number(data.ratio.toFixed(2));
  const navigate = useNavigate();
  const language = useSelector((state) => state.user.language);

  return (
    <Container>
      <Wrapper onClick={() => navigate(`/company/${data.corp_code}`)}>
        <TextWrapper>
          <div className="text-sm text-text-500">{data[`comp_name_${language}`]}</div>
        </TextWrapper>

        <div className="flex items-center justify-end gap-1 w-[78px]">
          <div className="mr-auto">
            <Img src={exposureImg} alt="exposure" className="w-4 h-4 mr-1" />
          </div>
          <div className="text-sm text-text-300">{data_} %</div>
        </div>
      </Wrapper>
    </Container>
  );
};

export default CompanyItem;
